<template>
  <div class="nav-container">
    <div class="container">
      <div class="nav">
        <div class="nav__items">
          <div class="nav__item">
            <div class="nav__title">
              <router-link to="/">Image Zoomer</router-link>
            </div>
          </div>
          <div v-if="isEditor" class="nav__item">
            <router-link to="/">Upload New Image</router-link>
          </div>
          <div v-if="isEditor" class="nav__item">
            Panel Width: <input v-model="canvasWidth" type="number" min="1" value="640" step="1">px.
          </div>
          <div v-if="isEditor" class="nav__item">
            Panel Height:
            <input v-model="canvasHeight" type="number" min="1" value="480" step="1">px.
          </div>
          <div v-if="isEditor" class="nav__item">
            <AddPanel/>
          </div>
        </div>
        <div class="nav__items">
          <div class="nav__item">
            <router-link to="/about">About</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddPanel from './AddPanel.vue';

export default {
  name: 'Nav',
  components: { AddPanel },
  computed: {
    isEditor() {
      return this.$route.name === 'edit';
    },
    canvasWidth: {
      get() {
        return this.$store.getters.canvasWidth;
      },
      set(value) {
        this.$store.dispatch('setCanvasWidth', value);
      },
    },
    canvasHeight: {
      get() {
        return this.$store.getters.canvasHeight;
      },
      set(value) {
        this.$store.dispatch('setCanvasHeight', value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../styles/variables';

  .nav-container {
    height: $navHeight;
    display: flex;
    background-color: $backgroundColor;
  }

  .nav {
    height: $navHeight;
    padding: 0 $spacing;
    display: flex;
    justify-content: space-between
  }

  .nav__items {
    display: flex;
    align-items: baseline;
    align-content: center;
  }

  .nav__item {
    margin: auto 5px auto 0;
  }

  input {
    width: 70px;
    font-size: 14px;
  }
</style>
